import React from 'react';
import {Route} from 'react-router-dom';
import slug from 'constants/slug';
import BiodiversityList from './BiodiversityList';
import BiodiversityCreate from './BiodiversityCreate';
import BiodiversityView from './BiodiversityView';
import BiodiversityEdit from './BiodiversityEdit';
import SpeciesEdit from './BiodiversityView/SpeciesManagement/SpeciesEdit';
import SpeciesCreate from './BiodiversityView/SpeciesManagement/SpeciesCreate';

export default (props) => [
  <Route
    exact
    key={slug.BIODIVERSITY.LIST}
    path={slug.BIODIVERSITY.LIST}
    render={(matchProps) => <BiodiversityList {...matchProps} {...props} />}
  />,
  <Route
    exact
    key={slug.BIODIVERSITY.CREATE}
    path={slug.BIODIVERSITY.CREATE}
    render={(matchProps) => <BiodiversityCreate {...matchProps} {...props} />}
  />,
  <Route
    exact
    key={slug.BIODIVERSITY.SPECIES}
    path={slug.BIODIVERSITY.SPECIES}
    render={(matchProps) => <BiodiversityView tabActive="SpeciesInfo" {...matchProps} {...props} />}
  />,
  <Route
    exact
    key={slug.BIODIVERSITY.DETAIL}
    path={slug.BIODIVERSITY.DETAIL}
    render={(matchProps) => <BiodiversityView tabActive="Detail" {...matchProps} {...props} />}
  />,
  <Route
    key={slug.BIODIVERSITY.EDIT}
    path={slug.BIODIVERSITY.EDIT}
    render={(matchProps) => <BiodiversityEdit {...matchProps} {...props} />}
  />,
  <Route
    key={slug.SPECIES.CREATE}
    path={slug.SPECIES.CREATE}
    render={(matchProps) => <SpeciesCreate {...matchProps} {...props} />}
  />,
  <Route
    key={slug.SPECIES.EDIT}
    path={slug.SPECIES.EDIT}
    render={(matchProps) => <SpeciesEdit {...matchProps} {...props} />}
  />,
];



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/index.js